import React from 'react';
import './contactUs.css';

import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import './leafletSetup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
const ContactUs = () => {
  const positionSaavedra = [-34.55482860553699, -58.49163850668955];
  const positionVillaUrquiza = [-34.56624405740024, -58.49099477653727];
  const handleDireccionClick = (direccion) => {
    // Construir la URL de Google Maps
    const urlEncodedDireccion = encodeURIComponent(direccion);
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${urlEncodedDireccion}`;

    // Detectar si el usuario está en un dispositivo móvil
    const userAgent = navigator.userAgent || navigator.vendor;
    const isMobile = /android|iphone|ipad|ipod/i.test(userAgent);

    if (isMobile) {
      // Intentar abrir la aplicación de Google Maps en dispositivos móviles
      window.location.href = `geo:0,0?q=${urlEncodedDireccion}`;
    } else {
      // Abrir Google Maps en el navegador para PC o tablet
      window.open(googleMapsUrl, '_blank');
    }
  };
  return (
    <div className='containerContactUs'>
      {/* Mapa */}
      <MapContainer
        center={[-34.5607662497022, -58.49069436913288]}
        zoom={13}
        style={{height: '40vh', width: '80%',display:'flex',justifySelf:'center',zIndex:0}}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='© OpenStreetMap contributors'
        />
        {/* Marcador para Saavedra */}
        <Marker position={positionSaavedra}>
          <Popup>
            Sucursal Saavedra: Av. Dr. Ricardo Balbín 4224
          </Popup>
        </Marker>
        {/* Marcador para Villa Urquiza */}
        <Marker position={positionVillaUrquiza}>
          <Popup>
            Sucursal Villa Urquiza: Díaz Colodrero 3223
          </Popup>
        </Marker>
      </MapContainer>

      {/* Direcciones */}
      <div className="direccion">
      <h3
        style={{ cursor: 'pointer' }}
        onClick={() =>
          handleDireccionClick(
            'Sucursal Saavedra: Av. Dr. Ricardo Balbín 4224, C1430 Cdad. Autónoma de Buenos Aires'
          )
        }
      >
        <FontAwesomeIcon icon={faLocationDot} style={{ marginRight: '8px', color: '#007bff' }} />
        Sucursal Saavedra: Av. Dr. Ricardo Balbín 4224, C1430 Cdad. Autónoma de Buenos Aires
      </h3>
      <h3
        style={{ cursor: 'pointer' }}
        onClick={() =>
          handleDireccionClick(
            'Sucursal Villa Urquiza: Díaz Colodrero 3223, C1431 Cdad. Autónoma de Buenos Aires'
          )
        }
      >
        <FontAwesomeIcon icon={faLocationDot} style={{ marginRight: '8px', color: '#007bff' }} />
        Sucursal Villa Urquiza: Díaz Colodrero 3223, C1431 Cdad. Autónoma de Buenos Aires
      </h3>
    </div>
    </div>
  );
};

export default ContactUs;
